import { lifecycle } from 'recompose'

export default lifecycle({
  componentDidMount() {
    const head: string | undefined = process.env.HEAD
    const tag: string | undefined = process.env.RELEASE_TAG

    if (!head && !tag) {
      console.info(
        `%c No "HEAD" or "RELEASE_TAG" environment variables were found to show here!`,
        'background: rgba(255,255,255,0.1); color: #FA2A2B;',
      )
    } else {
      if (head) {
        console.info(
          `%c Running application build (${head.substring(0, 7)})`,
          'background: #222; color: #57c7e8;',
        )
      }

      if (tag) {
        console.info(
          `%c Running application version (${tag})`,
          'background: #222; color: #57c7e8;',
        )
      }
    }
  },
})
